import {
  Component,
  OnInit,
  OnDestroy,
  Renderer2,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { CommonService } from '../../../../shared/services/common.service'
import { Router, ActivatedRoute } from '@angular/router'
import { Observable, of } from 'rxjs'

import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms'
import {
  CmsService,
  AuthService,
  User,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { switchMap } from 'rxjs/operators'
import { UserAccountFacade } from '@spartacus/user/account/root'
@Component({
  standalone: false,
  selector: 'vs-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss'],
})
export class OrderDetailComponent implements OnInit, OnDestroy {
  @Output() showProfileSuccess = new EventEmitter<boolean>()
  user$: Observable<User>

  public userTypes
  public userRoleModelOrder
  public showSuccess = false
  public userRolesOrderModel = ''
  public userShip = 'false'
  public userRolesOrder = 'userRolesOrder'
  myprofile: FormGroup
  myprofiledetails: FormGroup
  myprofilenotify: FormGroup
  personaldetail: FormGroup
  public roleObj
  //orderObj: any = this.userRoleModelOrder;
  defaultCarrierPreference = []
  shippingPreference
  @ViewChild('infoMsg', { static: true }) infoMsg: ElementRef
  @ViewChild('successMsg', { static: true }) successMsg: ElementRef
  incoTermCode: any
  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private router: Router,
    private cmsService: CmsService,
    private auth: AuthService,

    private renderer: Renderer2,
    private activatedRoute: ActivatedRoute,
    private globalMessageService: GlobalMessageService,
    private userAccountFacade: UserAccountFacade
  ) {}

  get formControlsDetails() {
    return this.myprofiledetails.controls
  }
  get carrier() {
    return this.myprofiledetails.get('carrier')
  }
  get incoTerm() {
    return this.myprofiledetails.get('incoTerm')
  }
  get shiptoname() {
    return this.myprofiledetails.get('shiptoname')
  }
  get shiptocontact() {
    return this.myprofiledetails.get('shiptocontact')
  }

  getOrderNotification() {
    this.defaultCarrierPreference = []
    const params = ['users', 'current', 'orderdetails']
    const apiUrl = this.commonService.constructUrl(params)
    this.commonService.getData(apiUrl).subscribe(
      (success) => {
        this.userTypes = success
        if (this.userTypes.partialShipping) {
          this.userShip = 'partial'
        } else {
          this.userShip = 'complete'
        }

        this.myprofiledetails.controls['shiptoname'].setValue(
          this.userTypes.shipToContactName
        )
        this.myprofiledetails.controls['shiptocontact'].setValue(
          this.userTypes.shipToContactPhone
        )
        this.userTypes.defaultCarrierPreference.forEach((element) => {
          if (element.isDefaultCarrierData === true) {
            this.defaultCarrierPreference.push(element)
            this.myprofiledetails.controls['carrier'].setValue(element.name)
          }
        })
        this.userTypes?.defaultIncoTerm.forEach((element) => {
          if (element.isDefaultIncoTermsData === true) {
            this.incoTermCode = element.code
            this.myprofiledetails.controls['incoTerm'].setValue(element.name)
          }
        })
        this.userTypes.defaultShippingPreference.forEach((element1) => {
          if (element1.isDefaultDeliveryMode) {
            this.userRolesOrderModel = element1.code
          }
        })
        this.userTypes.defaultCarrierPreference.forEach((element) => {
          if (element.isDefaultCarrierData === false) {
            this.defaultCarrierPreference.push(element)
          }
        })
        this.userTypes.defaultShippingPreference.forEach((element) => {
          if (element.isDefaultDeliveryMode === true) {
            this.shippingPreference = element.code
          }
        })
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  goToTop() {
    window.scrollTo(0, 0)
  }
  getOrderValue(data) {
    this.shippingPreference = data
  }
  closeOrderSuccessMsg(event) {
    this.showSuccess = false
  }
  sendOrderNotification() {
    let _this = this
    let partialShipFlagValue
    if (this.myprofiledetails.value.ship == 'partial') {
      partialShipFlagValue = true
    } else {
      partialShipFlagValue = false
    }
    const params = ['users', 'current', 'orderdetails']
    const apiUrl = this.commonService.constructUrl(params)
    let oderDetailObj = {
      partialShipping: partialShipFlagValue,
      defaultShippingPreferenceCode: this.shippingPreference,
      defaultCarrierPreferenceCode: this.myprofiledetails.value.carrier,
      shipToContactName: this.myprofiledetails.value.shiptoname,
      shipToContactPhone: this.myprofiledetails.value.shiptocontact,
      defaultIncoTermCode: this.incoTermCode,
    }

    this.commonService.postData(apiUrl, oderDetailObj).subscribe(
      (success) => {
        //  alert('done')
        // this.showSuccess = true;
        //  this.successMsg.nativeElement.style.display = 'block';
        this.globalMessageService.add(
          { key: 'myProfile.profileUpdated' },
          GlobalMessageType.MSG_TYPE_CONFIRMATION,
          180000
        )
        this.goToTop()
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  clearOrderDetail() {
    this.myprofiledetails.reset()
    this.getOrderNotification()
    //  this.userShip = 'false';
    this.userRolesOrder = 'userRolesOrder'
  }
  // getRadioValue(data) {
  //   this.myprofiledetails.controls.ship.setValue(data.target.value);
  // }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((success) => {})
    this.getOrderNotification()
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )

    this.user$.subscribe((success) => {})
    this.myprofiledetails = this.formBuilder.group({
      //     ship: new FormControl(''),
      userRolesOrder: new FormControl(''),
      carrier: new FormControl(null),
      shiptoname: new FormControl(''),
      shiptocontact: new FormControl(''),
      incoTerm: new FormControl(null),
    })
  }
  incotermChange() {
    this.incoTermCode = this.myprofiledetails.value.incoTerm
  }
  ngOnDestroy() {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_WARNING)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION)
  }
}
